var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBusket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#E7C0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.213 15.965c1.026 0 1.973.466 2.598 1.28.625.814.832 1.849.568 2.84l-1.93 7.238a3.28 3.28 0 0 1-3.166 2.433H15.615a3.28 3.28 0 0 1-3.165-2.432L8.795 13.617a.554.554 0 0 0-.534-.41H6.844a1.104 1.104 0 0 1 0-2.207h1.417c1.248 0 2.345.842 2.666 2.048l.777 2.917h20.509zM17.83 26.658a1.103 1.103 0 0 0 1.09-1.28l-.866-5.363a1.103 1.103 0 1 0-2.178.352l.866 5.363c.088.542.556.928 1.088.928zm5.011-.212c.61 0 1.104-.495 1.104-1.104v-4.964a1.104 1.104 0 0 0-2.207 0v4.965c0 .608.494 1.103 1.103 1.103zm5.952-.716.867-5.363a1.103 1.103 0 1 0-2.179-.352l-.866 5.363a1.103 1.103 0 1 0 2.178.352zM17.876 37.477a2.761 2.761 0 0 1-2.758-2.759 2.761 2.761 0 0 1 2.758-2.758 2.761 2.761 0 0 1 2.758 2.758 2.761 2.761 0 0 1-2.758 2.759zm9.93 0a2.761 2.761 0 0 1-2.759-2.759 2.761 2.761 0 0 1 2.758-2.758 2.761 2.761 0 0 1 2.759 2.758 2.761 2.761 0 0 1-2.759 2.759z",
    fill: "#9334ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBusket);
export default __webpack_public_path__ + "static/media/homeBusket.b42c7a705d3fb1005ac7a61544411186.svg";
export { ForwardRef as ReactComponent };